
/**
 * Error: 未知错误
 */
export const ERROR_000 = {
    message: '未知错误',
    level: 'Error'
}
